import React from 'react';
import { render } from 'react-dom';
import { FormattedHTMLMessage } from 'react-intl';
import { Form, Button, Table, Card, Accordion} from 'react-bootstrap';
import { I18n } from '../../../utils/I18n';
import { FormattedMessage } from 'react-intl';
import { Cookie } from '../../../utils/Cookies';
import { IoIosArrowDown,IoMdArrowDropdown,IoMdArrowDropup } from 'react-icons/io';
import UserProtocol from '../../../net/UserProtocol';
import AlertDialog from '../../../utils/AlertDialog';

const Columns = {
  UserID: 0,
  UserName: 1,
  Organize: 2,
  Part: 3,
  Permission: 4,
  EMail: 5,
  State: 6
};



export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      GroupCount: 0,
      BrandCount: 0,
      StoreCount: 0,

      SystemToggle: true,
      CustomerToggle: true,
      AccountToggle: true,

      SystemAnnouncement: [],


      showSystemMenu:true,
      showCustomerMenu:true,
      showAccountInFo:true,      

      UserList: [],
      AdminCount: 0,
      EditorCount: 0,
      ViewerCount: 0,
      
      complainTitle:"",
      complainText:"",
     
    };
    this.TitlehandleChange = this.TitlehandleChange.bind(this);
    this.complainTexthandleChange = this.complainTexthandleChange.bind(this);
    console.log("dashboard init.");
  }


  componentDidMount() {
    //索取系統公告
    fetch("/api/announcement/list",{credentials: 'include'})
    .then(res => res.json())
    .then(
      (result) => {
        console.log("getDashboardInfo:::")
        // console.log(JSON.stringify(result))
        // console.log(result.resultCode)
        // console.log(result.data)
        this.setState({SystemAnnouncement:result.data})
       
      },
      (error) => {
      console.log("error in dashboard:",error)
      }
    )
    // UserProtocol.ins().getReportInfo()
    UserProtocol.ins().getIssueList()
  }



// 系統公告伸縮toggle圖像轉換 
ClickToggleSys=()=>{
  if (this.state.SystemToggle===true){return ( < IoMdArrowDropup />);}
  else {return ( <IoMdArrowDropdown />);}
}

//顧客回報伸縮toggle圖像轉換 
ClickToggleCus=()=>{
  if (this.state.CustomerToggle===true){return ( < IoMdArrowDropup />);}
  else {return ( <IoMdArrowDropdown />);}
}

// 帳戶資訊伸縮toggle圖像轉換 
ClickToggleAcc=()=>{
  if (this.state.AccountToggle===true){return ( < IoMdArrowDropup />);}
  else {return ( <IoMdArrowDropdown />);}
}

//系統公告資訊呈現
AnnouncementTable=()=>{
console.log("AnnouncementTable")
console.log(this.state.SystemAnnouncement)
//將資訊推送進Array,一併return
let indents=[];
for(let i=0; i<this.state.SystemAnnouncement.length;i++){
// console.log(this.state.SystemAnnouncement[i]);
let rowtime=this.state.SystemAnnouncement[i].createDate.slice(0,10);
// console.log(rowtime)
let helloTime=rowtime.split("-");
// console.log(helloTime)
indents.push(
  <div>
<div className="row">
<text style={{color:"#0032A0",marginLeft: "10px" }}>{this.state.SystemAnnouncement[i].title}</text>
<text style={{marginLeft: "40px" }}>{helloTime[0]}<FormattedMessage id="dashboard.year" />{helloTime[1]}<FormattedMessage id="dashboard.month" />{helloTime[2]}<FormattedMessage id="dashboard.day" /></text>
            </div>
            <div className="row"  style={{marginTop: "5px",paddingLeft:"10px"}}>
            <text>{this.state.SystemAnnouncement[i].body}</text>
           </div>
           <hr></hr>
           </div>
);
}
return indents;
}



//系統公告隱藏
showSystemMenufun=()=>{
  if (this.state.showSystemMenu===true){return (
    <Accordion defaultActiveKey="0">
    <Card  style={{ width: '410px', marginTop: "10px", marginBottom: "10px",borderRadius:"3%" ,borderBottom: "1px solid #ccc"}}>
        <Card.Header className="rounded"  style={{backgroundColor:"white"}}>
          <div className="row">
            <text style={{ marginLeft: "150px" }}><b><FormattedMessage id="dashboard.publicnotification" /></b></text>

            <Accordion.Toggle  eventKey="0" style={{ marginLeft: "150px",border:"0",backgroundColor:"white" }} onClick={() => this.setState({SystemToggle:!this.state.SystemToggle})}>
            {this.ClickToggleSys()}
            </Accordion.Toggle>
          </div>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body className="rounded" style={{overflowY:"scroll",height:"300px"}}>
          {this.AnnouncementTable()}
          </Card.Body>
        </Accordion.Collapse>
    </Card>
    </Accordion>
     );}
  else{return}
};

// 打了客服回報標題
TitlehandleChange=(event)=>{
this.setState({complainTitle: event.target.value});
}

// 打了客服回報
complainTexthandleChange=(event)=>{
  this.setState({complainText: event.target.value});
}


//客服回報隱藏
showCustomerReplyfun=()=>{
  if (this.state.showCustomerMenu===true){return( 
    <Accordion  defaultActiveKey="0">
    <Card  style={{ width: '410px', marginTop: "20px", marginBottom: "10px",borderRadius:"3%",borderBottom: "1px solid #ccc" }}>
      
        <Card.Header style={{backgroundColor: "white"}}>
          <div className="row">
            <text style={{ marginLeft: "150px" }}><b><FormattedMessage id="dashboard.customerreply" /></b></text>

            <Accordion.Toggle eventKey="0" style={{ marginLeft: "140px", border:0,backgroundColor: "white"}} onClick={() => this.setState({CustomerToggle:!this.state.CustomerToggle})}>
            {this.ClickToggleCus()}
            </Accordion.Toggle>
          </div>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body style={{}}>
          <Form  >
            <Card.Title className="mb-1"><FormattedMessage id="dashboard.TitleText" /></Card.Title>
            <Form.Group className="mb-1" >
              <Form.Control type="text" required  value={this.state.complainTitle} onChange={this.TitlehandleChange}  />
            </Form.Group>
            <Card.Title className="mb-1"><FormattedMessage id="dashboard.ContentText" /></Card.Title>
            <Form>
              <Form.Group controlId="exampleForm.ControlTextarea1">
                <Form.Control as="textarea" rows="3" required   value={this.state.complainText} onChange={this.complainTexthandleChange} />
              </Form.Group>
            </Form>
            <Button 
            onClick={() =>{
              var url = '/api/system/issue/report';
              var data = {"title":this.state.complainTitle,"body":this.state.complainText};
             
              if (this.state.complainTitle===""){
                AlertDialog.show(I18n.t("msg.login.ReplyPost"), I18n.t("msg.login.ErrReplyTitle"));
                return;
              }
              if (this.state.complainText===""){
                AlertDialog.show(I18n.t("msg.login.ReplyPost"), I18n.t("msg.login.ErrReplyContent"));
                return;
              };
              fetch(url, {
                method: 'POST', // or 'PUT'
                credentials: 'include',
                body: JSON.stringify(data), // data can be `string` or {object}!
                headers: new Headers({
                  'Content-Type': 'application/json'
                })
              }).then(res => res.json())
              .catch(error => console.error('Error:', error))
              .then(response => console.log('Customer Reply::', response));

              AlertDialog.show(I18n.t("msg.login.ReplyPost"), I18n.t("msg.login.ReplySuccess"));
            }}
            variant="outline-light" style={{boxShadow: "2px 2px 10px #333", backgroundColor: "#0032A0",borderRadius:"10px",width:"100px" }}  >{I18n.t("dashboard.Submmit")}</Button>
            </Form>
          </Card.Body>
        </Accordion.Collapse>
    </Card>
    </Accordion>
  ) }
  else{return}
};

//帳戶資訊隱藏
showAccountInFofun=()=>{
  if (this.state.showAccountInFo===true){return( 
  
    <Accordion defaultActiveKey="0">
    <Card  style={{ width: '410px', marginTop: "10px", marginBottom: "10px",borderRadius:"3%",backgroundColor: "white" }}>
      
        <Card.Header style={{backgroundColor: "white"}}>
          <div className="row">
            <text style={{ marginLeft: "150px" }}><b><FormattedMessage id="dashboard.accountinfo" /></b></text>

            <Accordion.Toggle eventKey="0" style={{ marginLeft: "150px",backgroundColor: "white",border:"0" }} onClick={() => this.setState({AccountToggle:!this.state.AccountToggle})}>
            {this.ClickToggleAcc()}
            </Accordion.Toggle>
          </div>



        </Card.Header>

        <Accordion.Collapse eventKey="0">


          <Card.Body style={{height:"160px"}}>

            <div className="row">
      <text style={{color:"#0032A0",marginLeft: "10px" }}>白金會員(台灣)</text>
      <text style={{marginLeft: "100px" }}>2020年5月1日</text>
            </div>
            <div className="row"  style={{marginTop: "10px",paddingLeft:"10px"}}>
           <text style={{fontSize:18}}>會員到期日:2021年4月30日</text>
           </div>
           <Button variant="outline-light"
           href={"mailto:aiv_contact@xv-global.com"}
           style={{marginLeft:"10px",marginTop: "20px", width:"350px",borderRadius:"10px",boxShadow: "2px 2px 10px #333", backgroundColor: "#0032A0"}}>
              
              <FormattedMessage id="dashboard.ContactCustomService" /></Button>

          </Card.Body>
        </Accordion.Collapse>
     
    </Card>
    </Accordion>
    
    
    )}
  else{return}
}




  render() {
    return (
      <div className="d-flex align-items-end flex-column" style={{ height: "100%", paddingTop: "20px", paddingLeft: "2%", paddingRight: "2%", paddingBottom: "0px", }}>
        <div className="d-flex flex-row align-items-center w-100" >
          <h4><b><u><FormattedMessage id="mainPage.dashboard" /></u></b></h4>
        </div>

        {/* 黃色區塊 */}
        <div className="row" style={{ height: "78vh", width: "100%",  marginTop: "8px"}}>

          {/* 第一column */}
          <div style={{ width: "500px", height: "33%" }}>

            {/* 系統公告開始 */}
            {this.showSystemMenufun()}
            {/* 系統公告結束 */}

            {/* 客服回報 */}
            {this.showCustomerReplyfun()}
            {/* 客服回報結束 */}

          </div>
          {/* 第一 Column 結束*/}

          {/* 第二 Column */}
          <div style={{ width: "500px", height: "33%" }}>

            {/* 帳戶資訊 */}
            {this.showAccountInFofun()}

          </div>
          {/* 第2 Column 結束*/}


          {/* 第三 Column */}
          <div style={{ width: "500px", height: "33%" }}></div>
          {/* 第3 Column 結束*/}

        </div>
        {/* 黃色區域結束 */}

        {/* 腳跟區域 */}
        <footer className="mt-auto w-100" style={{ borderLeft: "1px solid #ccc" }}>
          <div className="d-flex flex-row h-25">
            <div style={{ backgroundColor: "#fff", borderTop: "1px solid #ccc", borderRight: "1px solid #ccc", paddingLeft: '10px', paddingRight: '10px' }}>
              <FormattedMessage id="userListPage.displayset" />
            </div>
            <div className="flex-fill" style={{ borderBottom: "1px solid #ccc" }} ></div>
          </div>
          <div className="h-75 p-2" style={{ backgroundColor: "#fff", borderRight: "1px solid #ccc" }}>
            <span style={{ marginLeft: "20px" }}><FormattedMessage id="userListPage.dpset.column" /></span>
            <div className="d-flex flex-wrap">
              <Form.Check type="checkbox" id="dpset.orgtree" label={I18n.t("dashboard.publicnotification")} custom style={{ marginLeft: "20px" }}
                onChange={() => this.setState((prev) => ({ showSystemMenu: !prev.showSystemMenu }))} checked={this.state.showSystemMenu}/>
              <Form.Check type="checkbox" id="dpset.userid" label={I18n.t("dashboard.customerreply")} custom style={{ marginLeft: "20px" }}
                onChange={() => this.setState((prev) => ({showCustomerMenu: !prev.showCustomerMenu }))} checked={this.state.showCustomerMenu}/>
              <Form.Check type="checkbox" id="dpset.username" label={I18n.t("dashboard.accountinfo")} custom style={{ marginLeft: "20px" }}
                onChange={() => this.setState((prev) => ({showAccountInFo: !prev.showAccountInFo }))} checked={this.state.showAccountInFo} />

            </div>
          </div>
        </footer>
      </div>
    );
  }
}